module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-72x72-46289fc46f8b838a4391dffe7edaaf0a.png";